export default __webpack_public_path__ + "static/media/39.e2ce0349.jpg";